export default __webpack_public_path__ + "static/media/prev.5cbd3b9e.png";